import script from "./SecondStep.vue?vue&type=script&setup=true&lang=js"
export * from "./SecondStep.vue?vue&type=script&setup=true&lang=js"

import "./SecondStep.vue?vue&type=style&index=0&id=beccdf90&scoped=true&lang=scss"

import exportComponent from "C:\\xampp\\htdocs\\bestphone\\main_apps\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-beccdf90"]])

export default __exports__